// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2w-IQ","inner":"Footer_inner__mgbMT","nextIcon":"Footer_nextIcon__2shiU","innerLeft":"Footer_innerLeft__NlWIA"};